import style from './reading-time.module.scss';

type readingTimeProps = {
  readingTime: string;
  articleLabel: string;
};

const ReadingTimeBlock = ({ readingTime, articleLabel }: readingTimeProps) => {
  return (
    <div className={style.reading__item}>
      <p className={style.reading__item__title}>{articleLabel}</p>
      <p className={style.reading__item__line}></p>
      <p className={style.reading__item__time}>{readingTime} min read</p>
    </div>
  );
};
export default ReadingTimeBlock;
